import { NgModule } from '@angular/core';
import { TabsComponent } from './tabs.component';
import { MatTabsModule } from '@angular/material/tabs';
import { CommonModule } from '@angular/common';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { UIRouterModule } from '@uirouter/angular';
import { NavigationTabsComponent } from './navigation-tabs/navigation-tabs.component';

@NgModule({
    imports: [CommonModule, MatTabsModule, UIRouterModule],
    declarations: [TabsComponent, NavigationTabsComponent],
    providers: [TabsModuleService],
    exports: [TabsComponent, NavigationTabsComponent],
})
export class FiTabsModule {}
